<script>

  import {API_PAY} from '../../common/api'
  import {statusEnum, statusOptions, methodEnum, methodOptions} from '../../assets/js/common'

  export default {
    name: 'UserSinglePayList',
    props: ["user_id"],
    data () {
      return {
        start_date: '2019-06-01',
        end_date: '2029-12-31',
        tableData: [],
        statusEnum,
        statusOptions,
        methodEnum,
        methodOptions
      }
    },
    created() {
      this.getDataList()
    },
    methods: {
      getDataList() {
        let params = {
          page_num: 1000,
          user_id: this.user_id,
          start_date: this.start_date,
          end_date: this.end_date
        }
        this.$http.GET(API_PAY, params,
          res => {
            this.tableData = res.result.list
          }, err => {
            this.$message.error(err.msg)
          })
      },
    },
  }

</script>

<template>
  <div>
    <el-table
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      size="small">
      <el-table-column label="用户编号" prop="number"></el-table-column>
      <el-table-column label="用户名" prop="user_name"></el-table-column>
      <el-table-column label="所属小区" prop="village_name"></el-table-column>
      <el-table-column label="上次表底" prop="last_amount"></el-table-column>
      <el-table-column label="本次表底" prop="now_amount"></el-table-column>
      <el-table-column label="用水量" prop="use_amount"></el-table-column>
      <el-table-column label="水费" prop="money"></el-table-column>
      <el-table-column label="水资源税" prop="tax"></el-table-column>
      <el-table-column label="实收水费" prop="real_money"></el-table-column>
      <el-table-column label="账户余额" prop="balance"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="{row}">
          {{ methodEnum[row.method] }}{{ statusEnum[row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="create_time" width="180px"></el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/user/UserSinglePayList.vue